export default "__VITE_ASSET__HKoJWuxY__"